import { PostJourneysSearchJourneyResponse } from 'src/sdk_checkin';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib';
import { CheckinSearchResultModel } from './checkin-search-result.state';

/** StateDetailsActions */
const ACTION_SET = '[CheckinSearchResult] set';
const ACTION_UPDATE = '[CheckinSearchResult] update';
const ACTION_RESET = '[CheckinSearchResult] reset';
const ACTION_FAIL = '[CheckinSearchResult] fail';
const ACTION_CANCEL_REQUEST = '[CheckinSearchResult] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[CheckinSearchResult] set from api';
const ACTION_UPDATE_FROM_API = '[CheckinSearchResult] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setCheckinSearchResult = createAction(ACTION_SET, props<WithRequestId<CheckinSearchResultModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateCheckinSearchResult = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<CheckinSearchResultModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetCheckinSearchResult = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelCheckinSearchResultRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failCheckinSearchResult = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setCheckinSearchResultFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<PostJourneysSearchJourneyResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateCheckinSearchResultFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<PostJourneysSearchJourneyResponse>>()
);
